import React, {useRef, useState} from 'react';
import {CardElement, Elements, injectStripe, StripeProvider} from 'react-stripe-elements';
import {ControlLabel, FormGroup, Row} from "react-bootstrap";
import StripePowered from '../../../../images/Powered by Stripe - black.svg'

const createOptions = () => {
    return {
        style: {
            base: {
                width: '100%',
                fontSize: '16px',
                color: '#424770',
                fontFamily: 'Open Sans, sans-serif',
                letterSpacing: '0.025em',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#c23d4b',
            }
        }
    }
};

const _CardForm = ({stripe, setIsValidCard, setStripePaymentMethod, loading}) => {
    const [errorMessage, setErrorMessage] = useState("")
    const cardElement = useRef()

    const handleCardChange = async (e) => {
        if (e.complete) {
            const {error, paymentMethod} = await stripe.createPaymentMethod('card', cardElement.current._element);
            if (error) {
                setErrorMessage(error.message)
            } else {
                setStripePaymentMethod(paymentMethod)
                setIsValidCard(true)
            }
        } else {
            setIsValidCard(false)
        }
        e.error ? setErrorMessage(e.error.message) : setErrorMessage('')
    }

    const generateCardNumberField = () =>
        <FormGroup bsSize="small" className='credential_input'>
            <ControlLabel className='d-flex'>
                <p className='bold bottom0'><span className='colorRed mr-3'>*</span>CARD</p>
            </ControlLabel>
            <CardElement
                ref={cardElement}
                onChange={(e) => handleCardChange(e)}
                {...createOptions()}
                disabled={loading}
            />
        </FormGroup>

    return (
        <div className="CardSubscritionDemo">
            <form>
                <Row className='textCenter mt-40'>
                    {generateCardNumberField()}
                </Row>
                <Row className='textCenter'>
                    <FormGroup bsSize="small" className='credential_input stripe-powered'>
                        <img src={StripePowered} alt='Stripe' style={{width: 150}}/>
                    </FormGroup>
                </Row>
                <Row className='textCenter'>
                    <div className="error text-danger" role="alert">
                        <strong>{errorMessage}</strong>
                    </div>
                </Row>
            </form>
        </div>
    );
}

const CardForm = injectStripe(_CardForm);

export const ChangeCardElement = ({
                                   setIsValidCard,
                                   setStripePaymentMethod,
                                   loading,
                                   stripePublishableKey
                               }) => (
    <StripeProvider apiKey={stripePublishableKey}>
        <Elements>
            <CardForm
                setIsValidCard={setIsValidCard}
                setStripePaymentMethod={setStripePaymentMethod}
                loading={loading}
            />
        </Elements>
    </StripeProvider>
);
